$(document).ready(function () {
    var machineSearchTabs = $('#machine-search-tabs');
    machineSearchTabs.on('change', '#form-machine-search #standard-producer, #form-machine-search #standard-type', function () {

        var searchForm = $('#form-machine-search');
        searchForm.easyOverlay('start');

        $('<input>').attr({
            type: 'hidden',
            id: 'ajax',
            name: 'ajax',
            value: 1
        }).appendTo(searchForm);

        $.post('portal/machine/form', searchForm.serialize(), function (response) {
            searchForm.replaceWith(response);
            searchForm.easyOverlay('stop');
        });
    });

    machineSearchTabs.on('change', '#form-machine-search #sorting-sort_field, #form-machine-search #sorting-sort_order', function () {
        $('#form-machine-search').submit();
    });
});